import i18n from '@/locales/i18n';
import { createRouter, createWebHistory } from 'vue-router';
import Layout from '@V/layout/Layout.vue';
import { useStore } from 'vuex';
const introduce = import('@/gaiaViews/introduce/index.vue');
const agreement = import('@V/enAgreement/index.vue');
const privacypolicy = import('@V/enPrivacypolicy/index.vue');
const myConsult = import('@/gaiaViews/myConsult/index.vue');
const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import('@V/login/index.vue')
  },
  {
    path: '/access-denied',
    name: 'shareAccessDenied',
    component: () => import('@V/botWeb/ShareAccessDenied.vue')
  },
  {
    path: '/auth/callback',
    name: 'authCallback',
    component: () => import('@V/auth/callback.vue')
  },
  {
    path: '/introduce',
    name: 'introduce',
    component: () => introduce
  },
  {
    path: '/myConsult',
    name: 'myConsult',
    component: () => myConsult
  },
  {
    path: '/m/myConsult',
    name: 'mMyConsult',
    component: () => import('@V/myConsult/mobile/index.vue')
  },
  {
    path: '/flow',
    name: 'flow',
    component: () => import('@V/flow/index.vue'),
    redirect: '/flow/space',
    children: [
      {
        path: 'space',
        name: 'flowSpace',
        component: () => import('@V/flow/FlowSpace.vue')
      },
      {
        path: 'flowJumpConfig',
        name: 'flowJumpConfig',
        component: () => import('@V/flow/JumpConfig/index.vue')
      },
      {
        path: 'flowIntentConfig',
        name: 'flowIntentConfig',
        component: () => import('@/views/flow/IntentConfig/index.vue')
      }
    ]
  },
  {
    path: '/codeEditor',
    name: 'codeEditor',
    component: () => import('@V/flow/CodeEditor/index.vue')
  },
  {
    path: '/packageList',
    name: 'packageList',
    component: () => import('@V/flow/PackageList/index.vue')
  },
  {
    path: '/flow/public/:id',
    name: 'flowPublic',
    component: () => import('@V/flow/index.vue')
  },
  {
    path: '/packageList',
    name: 'packageList',
    component: () => import('@V/flow/PackageList/index.vue')
  },
  {
    path: '/agentStore/agentDetails',
    name: 'agentStoreAgentDetails',
    component: () => import('@V/agentShop/agentDetails/index.vue')
  },
  {
    path: '/agents/agentDetails',
    name: 'agentsAgentDetails',
    component: () => import('@V/agentShop/agentDetails/index.vue')
  },
  {
    path: '/workspace/agentDetails',
    name: 'workspaceAgentDetails',
    component: () => import('@V/agentShop/agentDetails/index.vue')
  },
  {
    path: '/agents/platformsUpdate',
    name: 'agentsPlatformsUpdate',
    component: () => import('@V/agentPlatformsUpdate/index.vue')
  },
  {
    path: '/voiceAgent/platformsUpdate',
    name: 'voiceAgentPlatformsUpdate',
    component: () => import('@V/voiceAgent/publish/update.vue')
  },
  {
    path: '/aiWriteTemplate',
    name: 'aiWriteTemplate',
    component: () => import('@V/aiWrite/template/index.vue')
  },
  {
    path: '/aiWriteTemplate/publish',
    name: 'aiWriteTemplatePublish',
    component: () => import('@V/aiWrite/template/publish/index.vue')
  },
  {
    path: '/aiWriteTemplate/publishUpdate',
    name: 'aiWriteTemplatePublishUpdate',
    component: () => import('@V/aiWrite/template/publish/update.vue')
  },
  {
    path: '/aiWrite/task',
    name: 'aiWriteTask',
    component: () => import('@V/aiWrite/task/index.vue')
  },
  {
    path: '/aiWrite/testTaskList',
    name: 'aiWriteTestTaskList',
    component: () => import('@V/aiWrite/task/TestList.vue')
  },
  {
    path: '/aiWrite/taskManagement',
    name: 'aiWriteTaskManagement',
    component: () => import('@V/aiWrite/task/management.vue')
  },
  {
    path: '/multiAgent/details/:id',
    name: 'multiAgentDetails',
    component: () => import('@V/multiAgent/Detail/index.vue')
  },
  {
    path: '/multiAgentEmbed',
    name: 'multiAgentEmbed',
    component: () => import('@V/multiAgent/Embed/index.vue')
  },
  {
    path: '/taskFlowAgent/details',
    name: 'taskFlowAgentDetails',
    component: () => import('@V/taskFlowAgent/Detail/index.vue')
  },
  {
    path: '/aiWrite/article',
    name: 'aiWriteArticle',
    component: () => import('@V/aiWrite/article/index.vue')
  },
  {
    path: '/aiWrite/article-legacy',
    name: 'aiWriteArticleLegacy',
    component: () => import('@V/aiWrite/article/index-legacy.vue')
  },
  {
    path: '/aiWrite/article/history',
    name: 'aiWriteArticleHistory',
    component: () => import('@V/aiWrite/article/history.vue')
  },
  {
    path: '/workspace/agentDetails',
    name: 'workspaceAgentDetails',
    component: () => import('@V/agentShop/agentDetails/index.vue')
  },
  {
    path: '/resource/toolDetail/:id',
    name: 'toolDetail',
    component: () => import('@V/resource/ToolDetail.vue')
  },
  {
    path: '/composer/share',
    name: 'superEntrySessionShare',
    component: () => import('@V/sessionShare/index.vue'),
    meta: {
      hidden: true
    }
  },
  {
    path: '/composer/file-share',
    name: 'superEntryFileShare',
    component: () => import('@V/superEntry/pages/FileSharePage.vue'),
    meta: {
      hidden: true
    }
  },
  {
    path: '/',
    component: Layout,
    name: 'mainPageModule',
    module: 'mainPageModule',
    redirect: '/introduce',
    children: [
      {
        path: '/composer',
        name: 'superEntry',
        redirect: {
          name: 'superEntryConversation'
        },
        component: () => import('@V/superEntry/index.vue'),
        meta: {
          requiresSuperEntryOwner: true,
          superEntryLayout: true
        },
        children: [
          {
            path: 'session',
            name: 'superEntryConversation',
            component: () => import('@V/superEntry/pages/ConversationPage.vue'),
            meta: {
              requiresSuperEntryOwner: true,
              superEntryLayout: true,
              superEntryTitle: i18n.global.t(
                'router.index.9c510ef7a2db31a6bddf21a06f740e9a'
              ),
              superEntryDescription: i18n.global.t(
                'router.index.660f7d08e5273caf72ea2ea8ebb37e42'
              )
            }
          },
          {
            path: 'vibe/:sessionId?',
            name: 'superEntryVibeAgent',
            component: () =>
              import('@V/superEntry/pages/VibeAgentConversationPage.vue'),
            meta: {
              requiresSuperEntryOwner: true,
              superEntryLayout: true,
              superEntryTitle: 'Vibe Agent',
              superEntryDescription: i18n.global.t(
                'router.index.8b4cb21af661647652b85e4bb4801a77'
              )
            }
          },
          {
            path: 'vibe-debug/:sessionId',
            name: 'superEntryVibeAgentDebug',
            component: () =>
              import('@V/superEntry/pages/VibeAgentDebugPage.vue'),
            meta: {
              requiresSuperEntryOwner: true,
              superEntryLayout: true,
              superEntryTitle: i18n.global.t(
                'router.index.5b12cc768740792fbc2c8eef96d0c439'
              ),
              superEntryDescription: i18n.global.t(
                'router.index.1b4b94887c57a4d081789230f8fe7bf0'
              )
            }
          },
          {
            path: 'agent-config',
            name: 'superEntryAgentConfig',
            component: () => import('@V/superEntry/pages/AgentConfigPage.vue'),
            meta: {
              requiresSuperEntryOwner: true,
              superEntryLayout: true,
              superEntryTitle: i18n.global.t(
                'router.index.729dd97eeab86de09bfffd6495c2f085'
              ),
              superEntryDescription: i18n.global.t(
                'router.index.f9507cfa6858c9eff7f6af7c9b1b2538'
              )
            }
          },
          {
            path: 'scheduled-tasks',
            name: 'superEntryScheduledTasks',
            component: () =>
              import('@V/superEntry/pages/ScheduledTasksPage.vue'),
            meta: {
              requiresSuperEntryOwner: true,
              superEntryLayout: true,
              superEntryTitle: i18n.global.t(
                'router.index.9479a3e55e0d40ce737487156eaed412'
              ),
              superEntryDescription: i18n.global.t(
                'router.index.a092f2db1ea0d172bac3a722fe18d0fd'
              )
            }
          }
        ]
      },
      {
        path: '/home',
        name: 'home',
        component: () => import('@V/home/index.vue')
      },
      {
        path: '/botView',
        name: 'botView',
        component: () => import('@V/agentShop/agentDetails/index.vue')
      },
      {
        path: '/commonKnowledge',
        name: 'commonKnowledge',
        component: () => import('@V/commonKnowledge/index.vue')
      },
      {
        path: '/workspace',
        name: 'workspace',
        component: () => import('@V/agentProjectDev/index.vue')
      },
      {
        path: '/workspace/agentAnalysis',
        name: 'workspaceAgentAnalysis',
        component: () => import('@V/agentAnalysis/index.vue')
      },
      {
        path: '/taskFlowAgent/agentAnalysis',
        name: 'taskFlowAgentAgentAnalysis',
        component: () => import('@V/taskFlowAgent/Analysis/index.vue')
      },
      {
        path: '/resource',
        name: 'resource',
        component: () => import('@V/resource/index.vue')
      },
      {
        path: '/resource/pluginTool/:id',
        name: 'pluginTool',
        component: () => import('@V/resource/ToolList.vue'),
        meta: {
          hidden: true
        }
      },
      {
        path: '/resource/ideTool/:id',
        name: 'ideTool',
        component: () => import('@V/resource/IDETool.vue')
      },
      {
        path: '/resource/toolDetail/:id',
        name: 'toolDetail',
        component: () => import('@V/resource/ToolDetail.vue')
      },
      {
        path: '/resource/skillDetail/:id',
        name: 'skillDetail',
        component: () => import('@V/resource/skill/SkillDetail.vue')
      },
      {
        path: '/resource/skillEditor/:id',
        name: 'skillEditor',
        component: () => import('@V/resource/skill/SkillEditor.vue')
      },
      {
        path: '/resource/ideInfo/:id',
        name: 'ideInfo',
        component: () => import('@V/resource/IDEInfo.vue')
      },
      {
        path: '/resource/voiceprintDetail',
        name: 'voiceprintDetail',
        component: () => import('@V/resource/voiceprint/Detail.vue')
      },
      {
        path: '/publishManage',
        name: 'publishManage',
        component: () => import('@V/publishManage/index.vue')
      },
      {
        path: '/voiceTaskCenter',
        name: 'voiceTaskCenter',
        component: () => import('@V/voiceTaskCenter/index.vue')
      },
      {
        path: '/voiceTaskCenter/task/:taskId',
        name: 'voiceTaskCenterTaskDetail',
        component: () => import('@V/voiceTaskCenter/TaskDetail.vue')
      },
      {
        path: '/voiceTaskCenter/task/:taskId/call/:callId',
        name: 'voiceTaskCenterCallDetail',
        component: () => import('@V/voiceTaskCenter/CallDetail.vue')
      },
      {
        path: '/publishManage/agentAnalysis',
        name: 'publishManageAgentAnalysis',
        component: () => import('@V/agentAnalysis/index.vue')
      },
      {
        path: '/plugins',
        name: 'plugins',
        component: () => import('@V/plugins/index.vue')
      },
      {
        path: '/pluginManage',
        name: 'pluginmanage',
        component: () => import('@V/pluginManage/index.vue')
      },
      {
        path: '/flowManage',
        name: 'flowManage',
        component: () => import('@V/flowManage/index.vue')
      },
      {
        path: '/publicFlowManage',
        name: 'publicFlowManage',
        component: () => import('@V/publicFlowManage/index.vue')
      },
      {
        path: '/agentAnalysis',
        name: 'agentAnalysis',
        component: () => import('@V/agentAnalysis/index.vue')
      },
      {
        path: '/publicMemory',
        name: 'publicMemory',
        component: () => import('@V/publicMemoryNew/index.vue')
      },
      {
        path: '/homeland',
        name: 'homeland',
        component: () => import('@V/homeland/index.vue')
      },
      {
        path: '/agentStore',
        name: 'agentStore',
        component: () => import('@V/agentShop/index.vue')
      },
      {
        path: '/enterprise',
        name: 'enterprise',
        component: () => import('@V/enterprise/index.vue')
      },
      {
        path: '/enterpriseApproval',
        name: 'enterpriseApproval',
        component: () => import('@V/enterpriseApproval/index.vue')
      },
      {
        path: '/database',
        name: 'database',
        component: () => import('@V/database/index.vue')
      },
      {
        path: '/ai-write-recently-used',
        name: 'aiWriteRecentlyUsed',
        component: () => import('@V/aiWrite/task/management.vue')
      },
      {
        path: '/agentEvaluation',
        name: 'agentEvaluation',
        component: () => import('@V/agentEvaluation/index.vue')
      },
      {
        path: '/hardware/product',
        name: 'hardwareProduct',
        component: () => import('@V/hardware/product/index.vue')
      },
      {
        path: '/hardware/product/:id',
        name: 'hardwareProductDetail',
        component: () => import('@V/hardware/product/detail.vue')
      },
      {
        path: '/hardware/firmware',
        name: 'hardwareFirmware',
        component: () => import('@V/hardware/firmware/index.vue')
      },
      {
        path: '/hardware/logs',
        name: 'hardwareLogs',
        component: () => import('@V/hardware/logs/index.vue')
      },
      {
        path: '/agentEvaluation/taskDetail',
        name: 'taskDetail',
        meta: {
          hidden: false
        },
        component: () => import('@V/agentEvaluation/TaskDetail/index.vue')
      },
      {
        path: '/agentEvaluation/set',
        name: 'agentEvaluationSet',
        component: () => import('@V/agentEvaluation/index.vue')
      },
      {
        path: '/agentEvaluation/createEvaluationTask',
        name: 'agentEvaluationCreateEvaluationTask',
        component: () =>
          import('@V/agentEvaluation/CreateEvaluationTask/index.vue')
      },
      {
        path: '/agentEvaluation/createEvaluationSet',
        name: 'createEvaluationSet',
        meta: {
          hidden: true
        },
        component: () =>
          import('@V/agentEvaluation/CreateEvaluationSet/index.vue')
      },
      {
        path: '/agentEvaluation/manualLabel',
        name: 'manualLabel',
        meta: {
          hidden: true
        },
        component: () => import('@V/agentEvaluation/ManualLabel/index.vue')
      },
      {
        path: '/agentEvaluation/viewLabel',
        name: 'viewLabel',
        meta: {
          hidden: true,
          readonly: true
        },
        component: () => import('@V/agentEvaluation/ManualLabel/index.vue')
      },
      {
        path: '/agentMonitor',
        name: 'agentMonitor',
        component: () => import('@V/agentMonitor/index.vue')
      },
      {
        path: '/creditQuota',
        name: 'creditQuota',
        component: () => import('@V/creditQuota/index.vue')
      },
      {
        path: '/agentManagement',
        name: 'agentManagement',
        component: () => import('@V/agentManagement/index.vue')
      },
      {
        path: '/agentManagement/agentAnalysis',
        name: 'agentManagementAgentAnalysis',
        component: () => import('@V/agentAnalysis/index.vue')
      },
      {
        path: '/batchTask',
        name: 'batchTask',
        component: () => import('@V/batchTask/index.vue')
      },
      {
        path: '/batchTask/createEvaluationTask',
        name: 'batchTaskCreateEvaluationTask',
        meta: {
          hidden: true
        },
        component: () => import('@V/batchTask/CreateEvaluationTask/index.vue')
      },
      {
        path: '/batchTask/createEvaluationSet',
        name: 'batchTaskCreateEvaluationSet',
        meta: {
          hidden: true
        },
        component: () => import('@V/batchTask/CreateEvaluationSet/index.vue')
      },
      {
        path: '/multiAgentHistory',
        name: 'multiAgentHistory',
        component: () => import('@V/chatHistory/multiAgentHistory.vue')
      },
      {
        path: '/taskFlowAgentHistory',
        name: 'taskFlowAgentHistory',
        component: () => import('@V/taskFlowAgent/UseHistory/index.vue')
      },
      {
        path: '/chatHistory',
        name: 'botAnalysisChatHistory',
        component: () => import('@V/chatHistory/index.vue')
      },
      {
        path: '/logQuery',
        name: 'chatHistoryLogQuery',
        component: () => import('@/views/chatHistory/components/LogQuery.vue')
      },
      {
        path: '/multiAgentLogQuery',
        name: 'multiAgentLogQuery',
        component: () =>
          import('@V/chatHistory/components/multiAgentLogQuery.vue')
      },
      {
        path: '/autoTuning',
        name: 'agentOpsAutoTuning',
        component: () => import('@V/autoTuning/index.vue')
      },
      {
        path: '/autoTuning/create',
        name: 'autoTuningCreate',
        component: () => import('@V/autoTuning/create/index.vue')
      },
      {
        path: '/autoTuning/detail',
        name: 'autoTuningDetail',
        component: () => import('@V/autoTuning/detail/index.vue')
      },
      {
        path: '/autoTuning/publish',
        name: 'autoTuningPublish',
        component: () => import('@V/autoTuning/publish/index.vue')
      },
      {
        path: '/evaluationDimensions',
        name: 'agentOpsEvaluationDimensions',
        component: () => import('@V/evaluationDimensions/index.vue')
      },
      {
        path: '/autoTuning/intelligentOptimizationReport',
        name: 'autoTuningIntelligentOptimizationReport',
        component: () =>
          import('@V/autoTuning/intelligentOptimizationReport/index.vue')
      },
      {
        path: '/agentEvaluation/evaluator',
        name: 'evaluator',
        component: () =>
          import('@/views/agentEvaluation/evaluator/viewDetail/index.vue')
      },
      {
        path: '/evaluationDimensions/create',
        name: 'evaluationDimensionsCreate',
        component: () => import('@V/evaluationDimensions/create/index.vue')
      },
      {
        path: '/evaluationDimensions/detail/:id',
        name: 'evaluationDimensionsDetail',
        component: () => import('@V/evaluationDimensions/detail/index.vue')
      },
      {
        path: '/observability',
        name: 'agentOpsObservability',
        component: () => import('@V/observability/index.vue')
      },
      {
        path: '/observability/create',
        name: 'observabilityCreate',
        component: () => import('@V/observability/ObserveTask/index.vue')
      },
      {
        path: '/observability/detail',
        name: 'observabilityDetail',
        component: () => import('@V/observability/ObserveDetail/index.vue')
      },
      {
        path: '/observability/experimental-details',
        name: 'experimentalDetails',
        component: () =>
          import('@V/observability/ExperimentalDetails/index.vue')
      },
      {
        path: '/observability/msgLog',
        name: 'msgLog',
        component: () => import('@V/chatHistory/components/ChatLog.vue')
      },
      {
        path: '/trace',
        name: 'agentOpsTrace',
        component: () => import('@V/trace/index.vue')
      },
      {
        path: '/trace/detail',
        name: 'traceDetail',
        component: () => import('@V/trace/Detail/index.vue')
      },
      {
        path: '/trace/addToEvaluationSet',
        name: 'addToEvaluationSet',
        component: () => import('@V/trace/AddToEvaluationSet/index.vue')
      },
      {
        path: '/logAudit',
        name: 'logAudit',
        component: () => import('@V/logAudit/index.vue')
      },
      {
        path: '/aiWrite/history',
        name: 'aiWriteHistory',
        component: () => import('@V/aiWrite/template/history/index.vue')
      },
      {
        path: '/aiWrite/statistics',
        name: 'aiWriteStatistics',
        component: () => import('@V/aiWrite/template/statistics/index.vue')
      },
      {
        path: '/docCenter',
        name: 'docCenter',
        component: () => import('@V/docCenter/index.vue'),
        redirect: '/docCenter/manual',
        children: [
          {
            path: 'manual/:docId?',
            name: 'docCenterManual',
            component: () => import('@V/docCenter/ProductDoc/index.vue')
          },
          {
            path: 'oapi/:docId?',
            name: 'docCenterApi',
            component: () => import('@V/docCenter/ProductDoc/index.vue')
          }
        ]
      },
      {
        path: '/document',
        name: 'document',
        component: () => import('@V/docCenter/index.vue'),
        redirect: '/document/manual',
        children: [
          {
            path: 'manual/:docId?',
            name: 'documentManual',
            component: () => import('@V/docCenter/ProductDoc/index.vue')
          },
          {
            path: 'oapi/:docId?',
            name: 'documentApi',
            component: () => import('@V/docCenter/ProductDoc/index.vue')
          }
        ]
      }
    ]
  },
  {
    path: '/documentPublic',
    name: 'documentPublic',
    component: () => import('@V/docCenter/index.vue'),
    redirect: '/documentPublic/manual',
    children: [
      {
        path: 'manual/:docId?',
        name: 'documentPublicManual',
        component: () => import('@V/docCenter/ProductDoc/index.vue')
      },
      {
        path: 'oapi/:docId?',
        name: 'documentPublicApi',
        component: () => import('@V/docCenter/ProductDoc/index.vue')
      }
    ]
  },
  {
    path: '/cardFactory/editor/:id',
    name: 'cardFactoryEditor',
    meta: {
      noLayout: true
    },
    component: () => import('@V/cardFactory/editor/index.vue')
  },
  {
    path: '/multiAgent/:id',
    name: 'multiAgent',
    component: () => import('@V/multiAgent/index.vue')
  },
  {
    path: '/taskFlowAgent',
    name: 'taskFlowAgent',
    component: () => import('@V/taskFlowAgent/index.vue')
  },
  {
    path: '/aiWrite/taskFlow',
    name: 'aiWriteTaskFlow',
    component: () => import('@V/aiWrite/taskFlow/index.vue')
  },
  {
    path: '/agentRelease',
    name: 'agentRelease',
    component: () => import('@V/agentRelease/index.vue')
  },
  {
    path: '/botSetting',
    name: 'botSetting',
    component: () => import('@V/botSetting/index.vue')
  },
  {
    path: '/voiceAgentSetting',
    name: 'voiceAgentSetting',
    component: () => import('@V/voiceAgent/setting/index.vue')
  },
  {
    path: '/voiceAgentPublish',
    name: 'voiceAgentPublish',
    component: () => import('@V/voiceAgent/publish/index.vue')
  },
  {
    path: '/voiceAgent',
    name: 'voiceAgent',
    component: () => import('@V/voiceAgent/share/index.vue')
  },
  {
    path: '/voiceAgent/usage',
    name: 'voiceAgentUsage',
    component: () => import('@V/voiceAgent/usage/index.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/voiceAgent/history',
    name: 'voiceAgentHistory',
    component: () => import('@V/voiceAgent/history/index.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/botMedia',
    name: 'botMedia',
    component: () => import('@V/botMedia/index.vue')
  },
  {
    path: '/chatHistory/chatLog',
    name: 'chatLog',
    component: () => import('@V/chatHistory/components/ChatLog.vue')
  },
  {
    path: '/databaseTable',
    name: 'databaseTable',
    component: () => import('@V/database/tableList/index.vue'),
    redirect: '/databaseTable/list',
    children: [
      {
        path: 'list',
        name: 'tableList',
        component: () => import('@V/database/tableList/list/index.vue')
      },
      {
        path: 'setting',
        name: 'tableSetting',
        component: () => import('@V/database/tableList/setting/index.vue')
      },
      {
        path: 'knowledge',
        name: 'databaseKnowledge',
        component: () => import('@V/database/knowledge/index.vue')
      },
      {
        path: 'fieldTable',
        name: 'databaseFieldTable',
        component: () => import('@V/database/fieldTable/index.vue')
      }
    ]
  },
  {
    path: '/knowledge',
    name: 'knowledge',
    component: () => import('@V/knowledge/index.vue'),
    redirect: '/knowledge/list',
    children: [
      {
        path: 'list',
        name: 'knowledgeListV2',
        component: () => import('@V/knowledge/list/index.vue')
      },
      {
        path: 'detail',
        name: 'knowledgeDetail',
        meta: {
          active: 'knowledgeListV2'
        },
        component: () => import('@V/knowledge/detail/index.vue')
      },
      {
        path: 'agentic-detail',
        name: 'knowledgeAgenticDetail',
        meta: {
          active: 'knowledgeListV2'
        },
        component: () => import('@V/knowledge/agenticDetail/index.vue')
      },
      {
        path: 'setting',
        name: 'knowledgeSettingV2',
        component: () => import('@V/knowledge/setting/index.vue')
      },
      {
        path: 'uploadQa',
        name: 'knowledgeUploadQaV2',
        meta: {
          active: 'knowledgeListV2'
        },
        component: () => import('@V/knowledge/upload/Qa.vue')
      },
      {
        path: 'confWeb',
        name: 'confWeb',
        meta: {
          active: 'knowledgeListV2'
        },
        component: () => import('@V/knowledge/ConfWeb/index.vue')
      },
      {
        path: 'retrievalTest',
        name: 'retrievalTestV2',
        meta: {
          active: 'retrievalTestV2'
        },
        component: () => import('@V/knowledge/retrievalTest/index.vue')
      },
      {
        path: 'compare',
        name: 'knowledgeCompareV2',
        meta: {
          active: 'knowledgeCompareV2'
        },
        component: () => import('@V/knowledge/compare/index.vue')
      },
      {
        path: 'audit',
        name: 'auditCenterV2',
        meta: {
          active: 'auditCenterV2'
        },
        component: () => import('@V/knowledge/audit/index.vue')
      }
    ]
  },
  {
    path: '/compare/work',
    name: 'knowledgeCompareWorkV2',
    meta: {
      active: 'knowledgeCompareV2'
    },
    component: () => import('@V/knowledge/compare/work/index.vue')
  },
  {
    path: '/knowledge/uploadFile/:type',
    name: 'knowledgeUploadFile',
    meta: {
      active: 'knowledgeListV2'
    },
    component: () => import('@V/knowledge/upload/index.vue')
  },
  {
    path: '/previewFile/:uploadId',
    name: 'previewFile',
    component: () => import('@C/FilePreview/index.vue')
  },
  {
    path: '/botWeb',
    name: 'botWeb',
    component: () => import('@V/botWeb/index.vue')
  },
  {
    path: '/access-denied',
    name: 'shareAccessDenied',
    component: () => import('@V/botWeb/ShareAccessDenied.vue')
  },
  {
    path: '/visiteHome',
    name: 'visiteHome',
    component: () => import('@V/visiteHome/index.vue')
  },
  {
    path: '/manualReply',
    name: 'manualReply',
    component: () => import('@V/manualReply/index.vue')
  },
  {
    path: '/mobileManualReply',
    name: 'mobileManualReply',
    component: () => import('@V/mobileManualReply/index.vue')
  },
  {
    path: '/agreement',
    name: 'agreement',
    component: () => agreement
  },
  {
    path: '/privacyPolicy',
    name: 'privacyPolicy',
    component: () => privacypolicy
  },
  {
    path: '/baiyuAgreement',
    name: 'baiyuAgreement',
    component: () => import('@V/baiyuAgreement/index.vue')
  },
  {
    path: '/baiyuPrivacyPolicy',
    name: 'baiyuPrivacyPolicy',
    component: () => import('@V/baiyuPrivacypolicy/index.vue')
  },
  {
    path: '/link',
    name: 'link',
    component: () => import('@V/Link/index.vue')
  },
  {
    path: '/svg-icon',
    name: 'svg-icon',
    component: () => import('@V/svg-icon/index.vue')
  },
  {
    path: '/render',
    name: 'render',
    component: () => import('@V/aiWrite/render/index.vue')
  },
  {
    path: '/render-legacy',
    name: 'renderLegacy',
    component: () => import('@V/aiWrite/render/index-legacy.vue')
  },
  {
    path: '/download',
    name: 'downloadForPuppeteer',
    component: () => import('@V/downloadForPuppeteer/index.vue')
  },
  {
    path: '/excelParser',
    name: 'excelParser',
    component: () => import('@V/excelParser/index.vue')
  },
  {
    path: '/404',
    name: 'error404',
    component: () => import('@V/errorPage/404.vue')
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: () => import('@V/errorPage/404.vue')
  }
];
const router = createRouter({
  history: createWebHistory(),
  routes
});
router.beforeEach(async (to, from, next) => {
  const store = useStore();
  console.log(to);
  const whiteListNames = [
    'login',
    'shareAccessDenied',
    'introduce',
    'botWeb',
    'shareAccessDenied',
    'agreement',
    'privacyPolicy',
    'baiyuAgreement',
    'baiyuPrivacyPolicy',
    'downloadForPuppeteer',
    'render',
    'renderLegacy',
    'myConsult',
    'mMyConsult',
    'link',
    'multiAgentEmbed',
    'voiceAgentSetting',
    'voiceAgent',
    'document',
    'documentManual',
    'documentApi',
    'documentPublic',
    'documentPublicManual',
    'documentPublicApi',
    'superEntry',
    'superEntryConversation',
    'superEntryVibeAgent',
    'superEntryAgentConfig',
    'superEntryScheduledTasks',
    'superEntrySessionShare',
    'superEntryFileShare'
  ];
  const isWhiteListed = to.matched.some(record =>
    whiteListNames.includes(record.name)
  );
  const needPermission = !isWhiteListed;
  if (needPermission) {
    try {
      await store.dispatch('getPermission');
    } catch {
      console.log(
        i18n.global.t('router.index.3b848d612816cf2a03241ea73d5e5ee5')
      );
    }
  }
  next();
});
router.afterEach(() => {
  document.documentElement.classList.remove('dark');
});
export default router;
